import { Drawer } from 'element-ui'

const YDrawer = Drawer
YDrawer.$depends = [Drawer]
YDrawer.$name = 'y-drawer'
YDrawer._name = 'Drawer 抽屉'

export default YDrawer
